const state = {
    pageName: '',

    deadlineFilter: '',
    todoFilter: '',
    issFilter: '',
    vatFilter: '',
    tenFilter: '',
    otherTaxFilter: '',
    otherMissionFilter: '',
    situationReportingFilter: '',
    vatTvsFilter: '',
    deadlinesTableFilter: '',
    clientsValidationFilter: '',
    clientsActivationFilter: 'active',
    socialActionTypeFilter: '',

    year: 0,
    month: 0,
    perPage: 0,
    clientId: 0,
    needsUpdate: false,
    allRolesAssigned: false,
    initCompleted: false,

    creating: false,
    editing: false,

    init: false,

    loading: false,
    key: Date.now(),
}

const mutations = {
    UPDATE_KEY(state) {
        state.key = Date.now()
    },

    START_LOADING(state) {
        state.loading = true
    },

    STOP_LOADING(state) {
        state.loading = false
    },

    SKIP_INIT(state) {
        state.init = true
    },
    UN_SKIP_INIT(state) {
        state.init = false
    },

    SET_CREATING(state) {
        state.creating = true
    },
    RESET_CREATING(state) {
        state.creating = false
    },

    SET_EDITING(state) {
        state.editing = true
    },
    RESET_EDITING(state) {
        state.editing = false
    },

    SET_INIT_COMPLETED(state) {
        state.initCompleted = true
    },
    RESET_INIT_COMPLETED(state) {
        state.initCompleted = false
    },

    SET_CLIENT_ID(state, clientId) {
        state.clientId = clientId
    },
    RESET_CLIENT_ID(state) {
        state.clientId = 0
    },

    SET_PAGE_NAME(state, pageName) {
        state.pageName = pageName
    },
    RESET_PAGE_NAME(state) {
        state.pageName = ''
    },

    INIT_DEADLINE_FILTER(state) {
        state.deadlineFilter =
            state.deadlineFilter === '' ? 'all' : state.deadlineFilter
    },

    SET_DEADLINE_FILTER(state, deadlineFilter) {
        state.deadlineFilter = deadlineFilter
    },

    INIT_CLIENT_VALIDATION_FILTER(state) {
        state.clientsValidationFilter =
            state.clientsValidationFilter === ''
                ? 'all'
                : state.clientsValidationFilter
    },

    SET_CLIENT_VALIDATION_FILTER(state, clientsValidationFilter) {
        state.clientsValidationFilter = clientsValidationFilter
    },

    INIT_CLIENT_ACTIVATION_FILTER(state) {
        state.clientsActivationFilter =
            state.clientsActivationFilter === ''
                ? 'active'
                : state.clientsActivationFilter
    },

    SET_CLIENT_ACTIVATION_FILTER(state, clientsActivationFilter) {
        state.clientsActivationFilter = clientsActivationFilter
    },

    INIT_ISS_FILTER(state) {
        state.issFilter = state.issFilter === '' ? 'all' : state.issFilter
    },
    SET_ISS_FILTER(state, issFilter) {
        state.issFilter = issFilter
    },

    INIT_VAT_FILTER(state) {
        state.vatFilter = state.vatFilter === '' ? 'all' : state.vatFilter
    },
    SET_VAT_FILTER(state, value) {
        state.vatFilter = value
    },
    SET_VAT_TVS_FILTER(state, value) {
        state.vatTvsFilter = value
    },
    SET_OTHER_TAX_FILTER(state, otherTaxFilter) {
        state.otherTaxFilter = otherTaxFilter
    },
    SET_OTHER_MISSION_FILTER(state, otherMissionFilter) {
        state.otherMissionFilter = otherMissionFilter
    },
    SET_SITUATION_REPORTING_TAX_FILTER(state, situationReportingFilter) {
        state.situationReportingFilter = situationReportingFilter
    },
    INIT_TEN_FILTER(state) {
        state.tenFilter = state.tenFilter === '' ? 'all' : state.tenFilter
    },
    SET_TEN_FILTER(state, tenFilter) {
        state.tenFilter = tenFilter
    },

    INIT_TODO_FILTER(state) {
        state.todoFilter = state.todoFilter === '' ? 'undone' : state.todoFilter
    },
    SET_TODO_FILTER(state, todoFilter) {
        state.todoFilter = todoFilter
    },

    RESET_DEADLINES_TABLE_FILTER(state) {
        state.deadlinesTableFilter = ''
    },
    SET_DEADLINES_TABLE_FILTER(state, deadlinesTableFilter) {
        state.deadlinesTableFilter = deadlinesTableFilter
    },

    SET_CHARGE_TYPE(state, chargeType) {
        state.chargeType = chargeType
    },

    SET_NEEDS_UPDATE(state, needsUpdate) {
        state.needsUpdate = needsUpdate
    },
    SET_ALL_ROLES_ASSIGNED(state, allRolesAssigned) {
        state.allRolesAssigned = allRolesAssigned
    },

    INIT_YEAR(state) {
        state.year = state.year === 0 ? new Date().getFullYear() : state.year
    },
    INCREMENT_YEAR(state) {
        state.year++
    },
    DECREMENT_YEAR(state) {
        state.year--
    },
    SET_YEAR(state, year) {
        state.year = year
    },

    INIT_MONTH(state) {
        state.month =
            state.month === 0 ? new Date().getMonth() + 1 : state.month
    },
    SET_MONTH(state, month) {
        state.month = month
    },

    INIT_PER_PAGE(state) {
        state.perPage = state.perPage === 0 ? 25 : state.perPage
    },

    SET_PER_PAGE(state, perPage) {
        state.perPage = perPage
    },

    SET_SOCIAL_ACTION_TYPE_FILTER(state, value) {
        state.socialActionTypeFilter = value
    },

}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
